import { RemoteOrganizer } from '../types';
import { Dispatch, UnknownAction } from 'redux';
import { get } from '../utils';

const UPDATE = 'UPDATE_ORGANIZERS';

interface OrganizerAction extends UnknownAction {
  organizers: RemoteOrganizer[];
}

export function organizersReducer(organizers: RemoteOrganizer[] = [], action: OrganizerAction): RemoteOrganizer[] {
  if (action.type === UPDATE) {
    return action.organizers;
  }
  return organizers;
}

export function fetchOrganizersAction(dispatch: Dispatch): void {
  get<RemoteOrganizer[]>('/aktiviteter/api/organizers')
    .then((organizers) => {
      dispatch({ type: UPDATE, organizers });
    })
    .catch(function (ex) {
      console.error('Failed to fetch organizers', ex);
    });
}
